import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 15129 17108"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#2b2a29;stroke-width:247.938}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970276462256">
        <path
          d="M9218 399c366 366 366 960 0 1327-366 366-961 366-1327 0-367-367-367-961 0-1327 366-367 960-367 1327 0zM6720 2896c367 366 367 960 0 1327-366 366-960 366-1327 0-366-367-366-961 0-1327 367-367 961-367 1327 0zM4223 5393c367 367 367 961 0 1327-366 367-960 367-1326 0-367-366-367-960 0-1327 365-366 960-366 1326 0zM1726 7890c366 367 366 961 0 1327-367 367-961 367-1327 0-367-366-367-960 0-1327 366-366 960-366 1327 0zM9218 16709c366-366 366-960 0-1327-366-366-961-366-1327 0-367 367-367 961 0 1327 366 366 960 366 1327 0zM6720 14212c367-367 367-961 0-1327-366-367-960-367-1327 0-366 366-366 960 0 1327 367 366 961 366 1327 0zM4223 11715c367-367 367-960 0-1327-366-367-960-367-1326 0-367 367-367 960 0 1327 365 366 960 366 1326 0z"
          className="fill stroke1"
          style={{
            strokeWidth: 247.938,
          }}
        />
        <path
          d="M1726 9217c366-366 366-960 0-1327-367-366-961-366-1327 0-367 367-367 961 0 1327 366 367 960 367 1327 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 247.938,
          }}

        />
      </g>
      <g id="_1970276447792">
        <path
          d="M14730 399c366 366 366 960 0 1327-367 366-960 366-1327 0-366-367-366-961 0-1327 367-367 960-367 1327 0zM12233 2896c366 366 366 960 0 1327-367 366-961 366-1327 0-367-367-367-961 0-1327 366-367 960-367 1327 0zM9735 5393c367 367 367 961 0 1327-366 367-960 367-1327 0-366-366-366-960 0-1327 367-366 961-366 1327 0zM7238 7890c367 367 367 961 0 1327-366 367-960 367-1326 0-367-366-367-960 0-1327 366-366 960-366 1326 0zM14730 16709c366-366 366-960 0-1327-367-366-960-366-1327 0-366 367-366 961 0 1327 367 366 960 366 1327 0zM12233 14212c366-367 366-961 0-1327-367-367-961-367-1327 0-367 366-367 960 0 1327 366 366 960 366 1327 0zM9735 11715c367-367 367-960 0-1327-366-367-960-367-1327 0-366 367-366 960 0 1327 367 366 961 366 1327 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 247.938,
          }}

        />
        <path
          d="M7238 9217c367-366 367-960 0-1327-366-366-960-366-1326 0-367 367-367 961 0 1327 366 367 960 367 1326 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 247.938,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
